// extracted by mini-css-extract-plugin
export default {"title_container":"content_title_container__xRS60"};